import { Component } from '@angular/core';

import { ToastService } from '../../services/toast.service';

@Component({ selector: 'ngbd-toast-global', templateUrl: './toast.component.html' })
export class ToastComponent {
  constructor(public toastService: ToastService) { }

  showStandard(message) {
    this.toastService.show(message);
  }

  showSuccess(message) {
    this.toastService.show(message, { classname: 'bg-success text-light', delay: 10000 });
  }

  showDanger(dangerTpl) {
    this.toastService.show(dangerTpl, { classname: 'bg-danger text-light', delay: 15000 });
  }

  showDangerWithHeader(textHeader, text) {
    this.toastService.show(text, { classname: 'bg-danger text-light', delay: 5000, withHeader: true, headerText: textHeader, autoHide: true });
  }
}